<template>
  <el-card
    style="height: 100%; width: 100%"
    body-class="flex flex-col gap-4"
    :body-style="{
      height: '100%',
      width: '100%',
    }"
    shadow="always">
    <LicenseDetailsTable
      v-if="application"
      ref="licenseModelEditTable"
      class="h-full w-full"
      :software-licenses="allSoftwareLicenses"
      hide-header
      :application="application"
      :selectable="false"
      licenses-editable
      show-add-row
      :loading="loadingLicences"
      :sub-account-id="currentSubAccount"
      @software-changed="handleRefetchApplication()"
      @licenses-changed="handleRefetchApplication()" />
  </el-card>
</template>

<script setup lang="ts">
  import { computed, ref, watch } from 'vue'
  import { SoftwareLicense } from '@/client'
  import { useApplicationDetailsStore } from '@/stores/ApplicationDetailsView.store'
  import { useRoute } from 'vue-router'

  const route = useRoute()
  const applicationDetailsStore = useApplicationDetailsStore()

  const applicationIdParam = computed(() => {
    const param = route.params.id
    return Array.isArray(param) ? param[0] : (param as string)
  })

  watch(
    applicationIdParam,
    (id) => {
      if (id) {
        applicationDetailsStore.loadApplicationDetails(id)
      }
    },
    { immediate: true }
  )

  const currentSubAccount = ref<string | null>(
    (route.params.subAccountId as string) ?? null
  )

  watch(
    () => route.params.subAccountId,
    (newSubAccountId) => {
      currentSubAccount.value = Array.isArray(newSubAccountId)
        ? newSubAccountId[0]
        : (newSubAccountId as string) ?? null
    }
  )

  const application = computed(() => applicationDetailsStore.application)
  const allSoftwareLicenses = computed<SoftwareLicense[]>(
    () => applicationDetailsStore.licences
  )
  const loadingLicences = computed(
    () => applicationDetailsStore.loadingLicences
  )

  async function handleRefetchApplication() {
    await applicationDetailsStore.refreshLicences()
  }
</script>
